
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section id="home" className="hero-jumbotron">
      <div className="hero-jumbotron__overlay"></div>
      <div className="hero-jumbotron__content">
        <h1 className="hero-jumbotron__tagline">Equal access to Quality Education</h1>
        <p className="hero-jumbotron__subtitle">Empowering young minds through interactive learning</p>
        <div className="hero-jumbotron__actions">
          <Link to="/download" className="hero-btn download">
            Download App
          </Link>
          <Link to="/features" className="hero-btn features">
            Features
          </Link>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
